"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function combineVerifications(subVerificationResults, coursesNotConsumed, creditsRequired, ruleTitle) {
    if (creditsRequired === void 0) { creditsRequired = -1; }
    if (ruleTitle === void 0) { ruleTitle = "combined-results"; }
    return {
        ruleTitle: ruleTitle,
        pass: !subVerificationResults.find(function (r) { return !r.pass; }),
        coursesConsumed: subVerificationResults.reduce(function (consumed, result) { return consumed.concat(result.coursesConsumed); }, []),
        creditsFound: subVerificationResults
            .filter(function (r) { return r.pass; })
            .reduce(function (total, r) { return total + r.creditsFound; }, 0),
        creditsRequired: creditsRequired,
        coursesNotConsumed: coursesNotConsumed,
        issues: subVerificationResults.reduce(function (issues, result) { return issues.concat(result.issues); }, []),
        subVerificationResults: subVerificationResults
    };
}
exports.default = combineVerifications;
//# sourceMappingURL=combineVerifications.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/combineVerifications.js
// module id = 71
// module chunks = 22